import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./Ferramentas.module.css";

import LogoNasa from "../../Assets/logo-nasa.png";
import imcImgBaixo from "../../Assets/imcImg/baixo-peso.png";
import imcImgAdequado from "../../Assets/imcImg/peso-adequado.png";
import imcImgSobre from "../../Assets/imcImg/sobre-peso.png";
import imcImgObesidade from "../../Assets/imcImg/obesidade.png";

const Ferramentas = () => {
  useEffect(() => {
    document.title = "Ferramentas Online | Fohattech";
  }, []);

  return (
    <section className={styles.pageWrapper}>

      {/* LATERAL ADS */}
      <aside className={styles.ads}></aside>

      {/* CONTAINER CENTRAL */}
      <div className={styles.container}>

        <header className={styles.header}>
          <h1>Ferramentas Online</h1>
          <p>
            Acesse ferramentas gratuitas para cálculos, utilidades e consultas rápidas.
            Novas ferramentas serão adicionadas regularmente.
          </p>
        </header>

        <div className={styles.grid}>

          {/* MEMORY LAB */}
          <Link to="/tools/memory-lab" className={styles.card}>
            <div className={styles.cardContent}>
              <h2>Memory Lab</h2>
              <p>
                Treine sua memória com desafios progressivos de sequência numérica e testes cognitivos.
              </p>
            </div>

            <div className={styles.cardMediaIcon}>
              🧠
            </div>
          </Link>

          {/* INSTAGRAM RESIZE */}
          <Link to="/tools/instagram-resize" className={styles.card}>
            <div className={styles.cardContent}>
              <h2>Redimensionar para Instagram</h2>
              <p>
                Ajuste imagens para feed, stories e reels no tamanho ideal sem perder qualidade.
              </p>
            </div>

            <div className={styles.cardMediaIcon}>
              📸
            </div>
          </Link>

          {/* QR CODE */}
          <Link to="/tools/qr-code" className={styles.card}>
            <div className={styles.cardContent}>
              <h2>Gerador de QR Code</h2>
              <p>
                Crie QR Codes personalizados para links, textos e Wi-Fi. Baixe em PNG ou PDF.
              </p>
            </div>

            <div className={styles.cardMediaIcon}>
              📱
            </div>
          </Link>

          {/* ArrowForge */}
          <Link to="/tools/arrow-forge" className={styles.card}>
            <div className={styles.cardContent}>
              <h2>ArrowForge</h2>
              <p>
                Copie setas prontas (→ ↑ ↓ ⇄ ➜) para usar em textos, sites e redes sociais.
              </p>
            </div>

            <div className={styles.cardMediaIcon}>
              ➜
            </div>
          </Link>

          {/* Image to Pixel Art */}
          <Link to="/tools/image-to-pixel-art" className={styles.card}>
            <div className={styles.cardContent}>
              <h2>Image to Pixel Art</h2>
              <p>Converta imagens em pixel art para jogos e projetos criativos.</p>
            </div>

            <div className={styles.cardMediaIcon}>
              🎨
            </div>
          </Link>

          {/* DeckForge */}
          <Link to="/tools/deckforge" className={styles.card}>
            <div className={styles.cardContent}>
              <h2>DeckForge</h2>
              <p>Crie e personalize cartas de baralho para jogos ou impressão.</p>
            </div>

            <div className={styles.cardMediaIcon}>
              🃏
            </div>
          </Link>

          {/* COMPRESSIFY */}
          <Link to="/tools/compressify" className={styles.card}>
            <div className={styles.cardContent}>
              <h2>Compressify</h2>
              <p>Comprima imagens e reduza o tamanho dos arquivos rapidamente.</p>
            </div>

            <div className={styles.cardMediaIcon}>
              🗜️
            </div>
          </Link>

          {/* NASA */}
          <Link to="/tools/nasa-search" className={styles.card}>
            <div className={styles.cardContent}>
              <h2>Busca NASA</h2>
              <p>Explore imagens e dados oficiais da NASA.</p>
            </div>

            <div className={styles.cardMedia}>
              <img src={LogoNasa} alt="NASA Logo" />
            </div>
          </Link>

          {/* CONSUMO DE ÁGUA */}
          <Link to="/tools/water-intake" className={styles.card}>
            <div className={styles.cardContent}>
              <h2>Consumo de Água</h2>
              <p>
                Descubra quantos litros de água você deve beber por dia e acompanhe sua hidratação.
              </p>
            </div>

            <div className={styles.cardMediaIcon}>
              💧
            </div>
          </Link>

          {/* IMC */}
          <Link to="/tools/imc" className={styles.card}>
            <div className={styles.cardContent}>
              <h2>Calcular IMC</h2>
              <p>Descubra seu índice de massa corporal.</p>
            </div>

            <div className={styles.cardMediaRow}>
              <img src={imcImgBaixo} alt="Baixo peso" />
              <img src={imcImgAdequado} alt="Peso ideal" />
              <img src={imcImgSobre} alt="Sobrepeso" />
              <img src={imcImgObesidade} alt="Obesidade" />
            </div>
          </Link>

        </div>
      </div>

      {/* LATERAL ADS */}
      <aside className={styles.ads}></aside>

    </section>
  );
};

export default Ferramentas;